import {validateField, validateForm} from "../form/validator";
import {initMaskedInput, initPlaceholders} from "../form/inputs";
import autosize from "autosize/dist/autosize";

export function initContactsForm() {
    if (!$('#contact_form').length) {
        return
    }
    const $form = $('#contact_form');
    const $formWrapper = $('[data-contacts-form-wrapper]');

    const $finalMessageWrapper = $('[data-contacts-form-message]');
    const $submit = $form.find('#contacts_submit');

    const $closeSuccessForm = $('[data-close-contact-form]');

    autosize(document.querySelectorAll('textarea'));
    initPlaceholders();
    initMaskedInput();

    $form.find('input, textarea').on('change', (e) => {
        const $this = $(e.currentTarget);
        validateField($this);
        return false;
    })

    $submit.on('click', (e) => {
        if (validateForm($form)) {
            let formData = {};

            $form.find('input, textarea').each(function () {
                formData[this.name] = $(this).val();
            });

            formData['verification'] = '1';

            $.ajax({
                url: $form.attr('action'),
                type: 'POST',
                dataType: 'text',
                data: formData,
                success: () => {
                    $formWrapper.addClass('hide');
                    $finalMessageWrapper.removeClass('hide');
                },
                error: () => {
                    $formWrapper.addClass('hide');
                    $finalMessageWrapper.removeClass('hide');
                },
                timeout: 30000
            })
        }
        return false;
    })

    $closeSuccessForm.on('click', (e) => {
        $('[data-close-modal-button="contacts_form"]').click();
        setTimeout(() => {
            clearForm();
        }, 1000)
        return false;
    })

    function clearForm() {
        $formWrapper.removeClass('hide');
        $finalMessageWrapper.addClass('hide');
        $form.find('input, textarea').each((key, item) => {
            $(item).val('').blur();
            $(item).removeClass('success error').addClass('empty');
        });
    }
}
